import React, { useContext} from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Form, Formik } from 'formik';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import DynamicStylesLoader from '../ui/estilos/DynamicStylesLoader';
import { TexTranslate } from '../../translations/FlattenMessages';
import log from "../../images/logo_iproveedor.png";
import './sass/changePasswordMandatory.css'
import { Context } from '../context/Context';

export const ChangePasswordMandatory = () => {
    const intl = useIntl();
    const history = useHistory();
    const { app } = useContext(Context);
    const { nit } = useSelector(state => state.auth);
    const baseUrl = app.basePathFiles === "" ? "/" : app.basePathFiles;
    const logoImagen = nit ? `${baseUrl}afiliados/${nit}/img/logo.png` : log;

    const titleTextNotification = TexTranslate(intl, "changePass.Change Password", "changePass.Change Password");
    const textNotification = TexTranslate(intl, "changePass.Your password has expired, a link will be sent to the email registered on the platform so that you can change your password.");
    const classNotification = "alert alert-danger";

    const handleClose = () => {
        if(nit) {
            history.push(`/${app.baseName}/acceso/${nit}`, {});
            return;
        }
        history.push('/'+ app.baseName +'/index.html', {});
    }

    return (
        <>
            {nit && <DynamicStylesLoader cssPath={`${baseUrl}afiliados/${nit}/estilos.css`}/>}
            <div className={"section-changepass" + ( nit ? " section-changepassAfiliado" : "")}>
                <div className="contendor">
                    <div className="form">
                        <h2><img src={logoImagen} width="250" alt="logo" /></h2>
                        <div id="divText" className={classNotification + ` text-justify`}>
                            <h5 className='text-center'>
                                <FormattedMessage id={titleTextNotification} defaultMessage={titleTextNotification} />
                            </h5>
                            <FormattedMessage id={textNotification} defaultMessage={textNotification} />
                        </div>
                        <Formik
                            initialValues={{}}
                        >
                            {({}) => (
                                <Form>
                                    <Row>
                                        <Col lg={3} xs={4}>
                                            <button type="button" className="btn btn-outline-danger close-change-pass-mand" onClick={() => handleClose()} >
                                                <FormattedMessage id={`recoverPass.Close`} defaultMessage={"recoverPass.Close"} />
                                            </button>
                                        </Col>
                                    </Row>
                                </Form>
                            )}
                        </Formik>
                        
                        
                    </div>
                </div>
            </div>
        </>
    );

}